import React from 'react';

const WarehouseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M0 0H14V4.66667H0V0ZM0 6.22222H14V14H0V6.22222ZM3.88889 1.55556V3.11111H10.1111V1.55556H3.88889Z" fill="currentColor"/>
</svg>
);

export default WarehouseIcon;